export var EonSparkVersion;
(function (EonSparkVersion) {
    EonSparkVersion["EON_SPARK_VERSION_1_0"] = "1.0";
    EonSparkVersion["EON_SPARK_VERSION_2_0"] = "2.0";
    EonSparkVersion["EON_SPARK_VERSION_3_0"] = "3.0";
    EonSparkVersion["EON_SPARK_VERSION_3_1"] = "3.1";
})(EonSparkVersion || (EonSparkVersion = {}));
